import type { AppNotification, MySettings, MySettingsPatch } from '@/domain/types'
import { useApiQuery, type QueryState } from '@/api/useApiQuery'
import { useApiAction, type UseApiActionResult } from '@/api/useApiAction'

/**
 * The bell (api/src/routes/notifications.ts) and the caller's own settings
 * (api/src/routes/me.ts).
 */

export function useNotifications(refreshKey = 0): QueryState<AppNotification[]> {
  return useApiQuery<AppNotification[]>('/api/notifications', refreshKey)
}

/** The gold dot. */
export function useUnreadNotifications(refreshKey = 0): QueryState<{ count: number }> {
  return useApiQuery<{ count: number }>('/api/notifications/unread', refreshKey)
}

/** POST /api/notifications/read marks everything up to now as read. */
export function useNotificationAction(): UseApiActionResult<unknown> {
  return useApiAction<unknown>()
}

export function useMySettings(refreshKey = 0): QueryState<MySettings> {
  return useApiQuery<MySettings>('/api/me/settings', refreshKey)
}

/** PATCH /api/me/settings with a `MySettingsPatch`; answers with the new `MySettings`. */
export function useMySettingsAction(): UseApiActionResult<MySettings> {
  return useApiAction<MySettings>()
}

export type { MySettingsPatch }
